import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import AdminDashboard from './AdminDashboard'; // ✅ Import your AdminDashboard
import '../styles/HomePage.css';
 
const HomePage = ({
  user,
  handleOpenLoginModal,
  isLoggedIn,
  onLogout,
  onLoginClick,
  onRegisterClick,
  onLogin,
  onRegister,
  userRole,
}) => {
 
  const navigate = useNavigate();
  const location = useLocation();
 
  return (
    <div className="homepage">
      <Header
        isLoggedIn={isLoggedIn}
        userRole={userRole}
        onLogin={onLogin}
        onLogout={onLogout}
        onLoginClick={onLoginClick}
        onRegister={onRegister}
        onRegisterClick={onRegisterClick}
      />
 
     
      {location.pathname !== '/RegistrationForm' && (
        <>
          {isLoggedIn ? (
            userRole === 'admin' ? (
              <AdminDashboard />
            ) : (
              <Sidebar
                isLoggedIn={isLoggedIn}
                onLoginClick={handleOpenLoginModal}
                onLogin={onLogin}
              />
            )
          ) : (
            <Sidebar
              isLoggedIn={isLoggedIn}
              onLoginClick={handleOpenLoginModal}
              onLogin={onLogin}
            />
          )}
        </>
      )}
    </div>
  );
};
 
export default HomePage;